/**
 * Run `tick` every `ms` while the tab is visible; pause while it is hidden.
 *
 * The notification badge (45 s) and the admin vendor-health board (30 s) kept
 * polling in background tabs, so a consultant with ops open in five tabs sent
 * five streams of requests, and during an outage each one raised its own
 * connection toast (ops audit 2026-10-02, shell #15, admin #17). Coming back
 * to the tab runs `tick` once at once, so what is shown is fresh, then resumes
 * the interval. Returns a stop function that also removes the listener.
 */
export function pollWhileVisible(tick: () => void, ms: number): () => void {
  let timer: ReturnType<typeof setInterval> | null = null
  const start = () => {
    if (!timer) timer = setInterval(tick, ms)
  }
  const pause = () => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }
  const onVisibility = () => {
    if (document.visibilityState === 'visible') {
      tick()
      start()
    } else {
      pause()
    }
  }
  document.addEventListener('visibilitychange', onVisibility)
  if (document.visibilityState === 'visible') start()
  return () => {
    pause()
    document.removeEventListener('visibilitychange', onVisibility)
  }
}
